import styled, { breakpoints } from '../../../../../styles/theme';
import { StockModelCardHeaderStyled } from '../StockModelCardHeaderStyled';
import { rem } from 'polished';

export const StockModelCardHeaderStyledAC = styled(StockModelCardHeaderStyled)`
    .stockModelCard-header {
        &--heading {
            min-height: unset;
            color: ${({ theme }) => theme.colors.grey5};
        }
        &--engineInfo {
            font-size: ${rem('14px')};
            color: ${({ theme }) => theme.colors.grey5};
        }
    }
`;
